import clockOutHandler from './clockOutHandler';
import ClockOut from '../components/ClockOut';

export default clockOutHandler(ClockOut);
